import React, { useContext } from 'react'

import { FormattedMessage } from 'react-intl'

import { AnalyticsPostCampaignReportGlossaryEntry } from '@components/Analytics/PostCampaignReport/Glossary'
import { CPM_EXPLAINED } from '@constants'
import { CampaignContext } from '@context/Campaign'
import Theme from '@theme'
import { Link } from '@tribegroup'

export const AnalyticsPostCampaignReportGlossaryTikTok = () => {
  const {
    campaign: { indicative_budget_currency: currency },
  } = useContext(CampaignContext)

  return (
    <>
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.published" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="tiktok.spend"
        values={{
          taxDisplay: <FormattedMessage id={`core.currency.taxDisplay.${currency ?? 'generic'}`} />,
        }}
      />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.engagement" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="tiktok.cpe"
        values={{
          taxDisplay: <FormattedMessage id={`core.currency.taxDisplay.${currency ?? 'generic'}`} />,
        }}
      />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.views" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.followers" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.likes" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.comments" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.shares" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.engagementPct" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.viewPct" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="tiktok.cpv" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="tiktok.cpm"
        values={{
          link: (
            <Link href={CPM_EXPLAINED} target="_blank" color={Theme.primaryColor} lowercase>
              <FormattedMessage id="core.text.clickHere" />
            </Link>
          ),
        }}
      />
    </>
  )
}
